import { TranslatePipe, TranslateDirective, TranslateService } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { CommonBaseModule } from './../common/common.module';
import { ManualComponent } from './manual.component';
import {
    ManualFormComponent,
    ManualViewComponent,
    ManualTabsComponent,
    ManualBaseComponent,
    ManualListComponent,
    ManualRegistryComponent
} from './components/index';
import { ManualService } from './services/manual.services';
import {
    ManualListResolver,
    BusinessManualListResolver,
    PortalManualListResolver,
    ManualTreeDataResolver,
    ChooseBusinessResolver,
    AllManualListResolver,
    BusinessModeReslover,
    AdminUserResolver

} from './services/manual.resolver.service';
import { AssignManualComponent } from './components/assignmanual.component';
import { AssignManualListComponent } from './components/assign-manual-list.component';
import { EcplDocumentTreeModule } from 'src/app/shared/ecpl-document-tree/ecpl-document-tree.module';
import { EcplDocumentExplorerModule } from 'src/app/shared/ecpl-document-explorer';
import { EcplLarViewerModule } from './../../shared/ecpl-lar-viewer/ecpl-lar-viewer.module';
import { EcplArticleViewerModule } from 'src/app/shared/ecpl-article-viewer';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ContextMenuModule } from 'primeng/contextmenu';
import { FileUploadModule } from 'primeng/fileupload';
import { TabsModule } from 'primeng/tabs';
import { SelectButtonModule } from 'primeng/selectbutton';
@NgModule({ exports: [
        ManualComponent,
        ManualFormComponent,
        ManualViewComponent,
        ManualTabsComponent,
        ManualBaseComponent,
        ManualListComponent,
        ManualRegistryComponent,
        AssignManualComponent,
        AssignManualListComponent
    ],
    declarations: [
        ManualComponent,
        ManualFormComponent,
        ManualViewComponent,
        ManualTabsComponent,
        ManualBaseComponent,
        ManualListComponent,
        ManualRegistryComponent,
        AssignManualComponent,
        AssignManualListComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        TableModule,
        SharedModule,
        ButtonModule,
        DialogModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        ToggleSwitchModule,
        ContextMenuModule,
        FileUploadModule,
        AppSharedModule,
        TabsModule,
        SelectButtonModule,
        CommonBaseModule,
        TranslatePipe, TranslateDirective,
        EcplDocumentTreeModule,
        EcplDocumentExplorerModule,
        EcplLarViewerModule,
        EcplArticleViewerModule
    ],
    providers: [
        ManualService,
        ManualListResolver,
        PortalManualListResolver,
        BusinessManualListResolver,
        ManualTreeDataResolver,
        TranslateService,
        ChooseBusinessResolver,
        AllManualListResolver,
        BusinessModeReslover,
        AdminUserResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ManualModule { }
